export default __webpack_public_path__ + "static/media/blumon.7dbcbe2b.png";